module.exports = __webpack_public_path__ + "img/france_3.fc126222.png";